import React, { useState } from "react";
import { getTextParts, normalizeUrl } from "../lib/utils";

const ReadMore = ({ text = "", limit = 50 }) => {
  const [readMore, setReadMore] = useState(false);

  const words = text.split(/\s+/).filter(Boolean);
  const shouldTruncate = words.length > limit;
  const displayedText = shouldTruncate && !readMore ? `${words.slice(0, limit).join(" ")}...` : text;

  const renderText = (value) => {
    return getTextParts(value).map((part, index) =>
      part.isUrl ? (
        <a key={index} href={normalizeUrl(part.value)} target="_blank" rel="noopener noreferrer" className="font-medium text-purple-600 hover:text-purple-700 hover:underline break-all" onClick={(e) => e.stopPropagation()}>
          {part.value}
        </a>
      ) : (
        <React.Fragment key={index}>{part.value}</React.Fragment>
      )
    );
  };

  if (!text) return null;

  return (
    <>
      {renderText(displayedText)}

      {shouldTruncate && (
        <button type="button" className="ml-1 cursor-pointer font-medium text-purple-600 hover:underline" onClick={() => setReadMore((prev) => !prev)}>
          {readMore ? "show less" : "read more"}
        </button>
      )}
    </>
  );
};

export default ReadMore;